export class Credencial {
  login: string;
  senha: string;
  
}
